import {api, responseBody} from "./apiBase.service";

const Attachments = {
    byIdDirectDownload: (id: string) => api.get(`/Attachment/${id}/DirectDownload`),
    };
export default Attachments